var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellNoti = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7E869E",
    strokeWidth: 1.778
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.597 11.962a7.448 7.448 0 0 1 14.806 0l.336 3.021.008.077a10.7 10.7 0 0 0 1.47 4.306l.771 1.284c.7 1.166 1.05 1.749.974 2.227-.05.318-.214.608-.461.815-.372.31-1.051.31-2.41.31H7.91c-1.36 0-2.04 0-2.41-.31a1.33 1.33 0 0 1-.462-.815c-.076-.478.274-1.061.973-2.227l.771-1.284.04-.067a10.7 10.7 0 0 0 1.44-4.315z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12.136 24.541c.228.992.73 1.87 1.429 2.495S15.12 28 16 28s1.736-.339 2.435-.964c.699-.626 1.2-1.503 1.429-2.495"
  }))));
};
export default SvgBellNoti;